// deps
import React, { ReactElement, useMemo } from "react";
import { getCloudinaryUrl } from "@swiggy-private/core-ui";

// interfaces
import { BannerData } from "@payment-ui/interfaces/PaymentBanner";

// styles
import styles from "../PaymentBanner.scss";

// test-ids
import { PAYMENT_BANNER_TEST_IDS } from "@swiggy-private/payment-test-ids";

interface KYCMediaBannnerProps {
    banner: BannerData;
    handleClick: (e: React.MouseEvent) => void;
}

export function KYCMediaBannner(props: KYCMediaBannnerProps): ReactElement {
    const { banner, handleClick } = props;

    const backgroundStyle = useMemo(() => {
        const backgroundColors = (banner.backgroundColor ?? "").split(",");
        const background =
            backgroundColors.length === 1
                ? backgroundColors[0]
                : `linear-gradient(to right, ${backgroundColors[0]}, ${backgroundColors[1]})`;
        return { background };
    }, [banner.backgroundColor]);

    return (
        <div
            onClick={handleClick}
            className={styles.kycBanner}
            style={backgroundStyle}
            data-testid={PAYMENT_BANNER_TEST_IDS.KYC_CONATINER}
        >
            <div className={styles.kycBannerContent}>
                <div className={styles.kycBannerTitle}>{banner.title}</div>
                <div className={styles.kycBannerDesc}>{banner.description}</div>
            </div>
            <img src={getCloudinaryUrl(banner.backgroundImage)} className={styles.kycBannerImage} alt={banner.title} />
        </div>
    );
}
